/*
|----------------------------------------------------------
|   App Entry Point:
|---------------------------------------------------------
|   Use this index file to add all modules needed
|   to run the system.
|
|   The main bundle.js file will be generated only from
|   this entry point.
|
*/

import './weatherwidget';
import './pjax';

/**
 * Outputs the production environment to console
 *
 * TODO: ONLY OUTPUT THIS WHEN NOT IN THE PRODUCTION SERVER!!
 */
console.log("ENVIRONMENT: ", process.env.NODE_ENV);
